import graphql__868b2a44673d7419a59e from "./__generated__/CommentsPanelManagerQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";
import classNames from "classnames";

import CommentsPanel from "./CommentsPanel";
import { COMMENTS_BATCH_SIZE as commentsCount } from "./CommentsList";
import Spinner from "../Utils/Spinner";

const CommentsPanelManager = props => {
  const { commentableId } = props;

  const className = classNames(["comments-panel", props.className]);

  return (
    <div className={className}>
      <AppQueryRenderer
        query={CommentsPanelManagerQuery}
        variables={{ commentableId, commentsCount }}
        component={CommentsPanel}
        additionalProps={props}
        loader={<Spinner className="box" />}
      />
    </div>
  );
};

const CommentsPanelManagerQuery = graphql__868b2a44673d7419a59e;

export default CommentsPanelManager;
